// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"f9f8f2ba","914":"307e7667","945":"41548701"}[chunkId] + ".chunk.css";
};